export default "__VITE_ASSET__DQf7WFTR__"